export interface ProductSpec {
  en: string;
  fr: string;
  ar: string;
}

export interface Product {
  id: string;
  slug: string;
  nameKey: string;
  scientificName: string;
  commonNameFR: string;
  commonNameEN: string;
  commonNameAR: string;
  image: string;
  alt: string;
  category: string;
  categoryKey: string;
  descriptionKey: string;
  origin: ProductSpec;
  method: ProductSpec;
  processing: ProductSpec;
  packaging: ProductSpec;
}

export const products: Product[] = [
  {
    id: 'product_1',
    slug: 'octopus',
    nameKey: 'catalog.fish.octopus',
    scientificName: 'Octopus vulgaris',
    commonNameFR: 'Poulpe',
    commonNameEN: 'Common octopus',
    commonNameAR: 'أخطبوط',
    image: '/assets/products/1- Octopus vulgaris.jpeg',
    alt: 'Octopus vulgaris - Common octopus from Mauritanian Atlantic waters',
    category: 'Céphalopodes / Crustacés',
    categoryKey: 'catalog.cat.cephalopodesCrustaces',
    descriptionKey: 'catalog.desc.octopus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_2',
    slug: 'squid',
    nameKey: 'catalog.fish.squid',
    scientificName: 'Loligo vulgaris',
    commonNameFR: 'Calmar',
    commonNameEN: 'European squid',
    commonNameAR: 'حبار كالاماري',
    image: '/assets/products/2- Loligo vulgaris.jpeg',
    alt: 'Loligo vulgaris - European squid from Mauritanian Atlantic waters',
    category: 'Céphalopodes / Crustacés',
    categoryKey: 'catalog.cat.cephalopodesCrustaces',
    descriptionKey: 'catalog.desc.squid',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_3',
    slug: 'cuttlefish',
    nameKey: 'catalog.fish.cuttlefish',
    scientificName: 'Sepia officinalis',
    commonNameFR: 'Seiche commune',
    commonNameEN: 'Common cuttlefish',
    commonNameAR: 'حبار',
    image: '/assets/products/3- Sepia Officinalis.jpeg',
    alt: 'Sepia officinalis - Common cuttlefish from Mauritanian Atlantic waters',
    category: 'Céphalopodes / Crustacés',
    categoryKey: 'catalog.cat.cephalopodesCrustaces',
    descriptionKey: 'catalog.desc.cuttlefish',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_4',
    slug: 'spiny-lobster',
    nameKey: 'catalog.fish.lobster',
    scientificName: 'Palinurus mauritanicus',
    commonNameFR: 'Langouste rose',
    commonNameEN: 'Pink spiny lobster',
    commonNameAR: 'جراد البحر',
    image: '/assets/products/4- Palinurus mauritanicus.jpeg',
    alt: 'Palinurus mauritanicus - Pink spiny lobster from Mauritanian Atlantic waters',
    category: 'Céphalopodes / Crustacés',
    categoryKey: 'catalog.cat.cephalopodesCrustaces',
    descriptionKey: 'catalog.desc.lobster',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_5',
    slug: 'shrimp',
    nameKey: 'catalog.fish.shrimp',
    scientificName: 'Parapenaeus longirostris',
    commonNameFR: 'Crevette rose',
    commonNameEN: 'Deep water rose shrimp',
    commonNameAR: 'روبيان',
    image: '/assets/products/5- Parapenaeus Longirostris.jpeg',
    alt: 'Parapenaeus longirostris - Deep water rose shrimp from Mauritanian Atlantic waters',
    category: 'Céphalopodes / Crustacés',
    categoryKey: 'catalog.cat.cephalopodesCrustaces',
    descriptionKey: 'catalog.desc.shrimp',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_9',
    slug: 'cynoglossus-senegalensis',
    nameKey: 'catalog.fish.cynoglossus',
    scientificName: 'Cynoglossus senegalensis',
    commonNameFR: 'Sole-langue sénégalaise',
    commonNameEN: 'Senegalese tonguesole',
    commonNameAR: 'سمك اللسان السنغالي',
    image: '/assets/products/6- Cynoglossus senegalensis \'.jpeg',
    alt: 'Cynoglossus senegalensis - Senegalese tonguesole from Mauritanian Atlantic waters',
    category: 'Soles',
    categoryKey: 'catalog.cat.soles',
    descriptionKey: 'catalog.desc.cynoglossus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_10',
    slug: 'solea-senegalensis',
    nameKey: 'catalog.fish.soleaSenegalensis',
    scientificName: 'Solea senegalensis',
    commonNameFR: 'Sole de Roche',
    commonNameEN: 'Senegalese sole',
    commonNameAR: 'موسى سنغالي',
    image: '/assets/products/7- Solea senegalensis \'.jpeg',
    alt: 'Solea senegalensis - Senegalese sole from Mauritanian Atlantic waters',
    category: 'Soles',
    categoryKey: 'catalog.cat.soles',
    descriptionKey: 'catalog.desc.soleaSenegalensis',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_11',
    slug: 'solea-solea',
    nameKey: 'catalog.fish.soleaSolea',
    scientificName: 'Solea solea',
    commonNameFR: 'Sole Perdrix juive',
    commonNameEN: 'Bastard sole',
    commonNameAR: 'موسى شائع',
    image: '/assets/products/8- Solea Solea \'.jpeg',
    alt: 'Solea solea - Bastard sole from Mauritanian Atlantic waters',
    category: 'Soles',
    categoryKey: 'catalog.cat.soles',
    descriptionKey: 'catalog.desc.soleaSolea',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_12',
    slug: 'synaptura-cadenati',
    nameKey: 'catalog.fish.synaptura',
    scientificName: 'Synaptura cadenati',
    commonNameFR: 'Sole Tigrée',
    commonNameEN: 'Guinean sole',
    commonNameAR: 'موسى كاديناتي',
    image: '/assets/products/9- Synaptura cadenati.jpeg',
    alt: 'Synaptura cadenati - Guinean sole from Mauritanian Atlantic waters',
    category: 'Soles',
    categoryKey: 'catalog.cat.soles',
    descriptionKey: 'catalog.desc.synaptura',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_13',
    slug: 'psettodes-belcheri',
    nameKey: 'catalog.fish.psettodes',
    scientificName: 'Psettodes belcheri',
    commonNameFR: 'Turbot',
    commonNameEN: 'Dogsole',
    commonNameAR: 'هلبوت بيلشر',
    image: '/assets/products/10- Psettodes belcheri.jpeg',
    alt: 'Psettodes belcheri - Dogsole from Mauritanian Atlantic waters',
    category: 'Soles',
    categoryKey: 'catalog.cat.soles',
    descriptionKey: 'catalog.desc.psettodes',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_14',
    slug: 'epinephelus-aeneus',
    nameKey: 'catalog.fish.epinephelusAeneus',
    scientificName: 'Epinephelus aeneus',
    commonNameFR: 'Mérou blanc',
    commonNameEN: 'White grouper',
    commonNameAR: 'هامور أبيض',
    image: '/assets/products/11- Epinephelus aeneus.jpeg',
    alt: 'Epinephelus aeneus - White grouper from Mauritanian Atlantic waters',
    category: 'Mérous',
    categoryKey: 'catalog.cat.merous',
    descriptionKey: 'catalog.desc.epinephelusAeneus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_15',
    slug: 'epinephelus-guaza',
    nameKey: 'catalog.fish.epinephelusGuaza',
    scientificName: 'Epinephelus guaza',
    commonNameFR: 'Mérou brun',
    commonNameEN: 'Dusky grouper',
    commonNameAR: 'هامور داكن',
    image: '/assets/products/12- Epinephelus guaza.jpeg',
    alt: 'Epinephelus guaza - Dusky grouper from Mauritanian Atlantic waters',
    category: 'Mérous',
    categoryKey: 'catalog.cat.merous',
    descriptionKey: 'catalog.desc.epinephelusGuaza',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_16',
    slug: 'pseudotolithus-senegalensis',
    nameKey: 'catalog.fish.pseudotolithus',
    scientificName: 'Pseudotolithus senegalensis',
    commonNameFR: 'Courbine du Sénégal',
    commonNameEN: 'Senegalese croaker',
    commonNameAR: 'أوتوليث سنغالي',
    image: '/assets/products/13- Pseudotolithus senegalensis.jpeg',
    alt: 'Pseudotolithus senegalensis - Senegalese croaker from Mauritanian Atlantic waters',
    category: 'Courbines / Dorades / Pagres',
    categoryKey: 'catalog.cat.courbinesDorades',
    descriptionKey: 'catalog.desc.pseudotolithus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_17',
    slug: 'sparus-aurata',
    nameKey: 'catalog.fish.sparusAurata',
    scientificName: 'Sparus aurata',
    commonNameFR: 'Dorade royale',
    commonNameEN: 'Gilthead seabream',
    commonNameAR: 'دنيس ذهبي',
    image: '/assets/products/14- Sparus aurata.jpeg',
    alt: 'Sparus aurata - Gilthead seabream from Mauritanian Atlantic waters',
    category: 'Courbines / Dorades / Pagres',
    categoryKey: 'catalog.cat.courbinesDorades',
    descriptionKey: 'catalog.desc.sparusAurata',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_18',
    slug: 'pagrus-auriga',
    nameKey: 'catalog.fish.pagrusAuriga',
    scientificName: 'Pagrus auriga',
    commonNameFR: 'Dorade',
    commonNameEN: 'Redbanded seabream',
    commonNameAR: 'باغروس إبطي',
    image: '/assets/products/15- Pagrus Auriga.jpeg',
    alt: 'Pagrus auriga - Redbanded seabream from Mauritanian Atlantic waters',
    category: 'Courbines / Dorades / Pagres',
    categoryKey: 'catalog.cat.courbinesDorades',
    descriptionKey: 'catalog.desc.pagrusAuriga',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_19',
    slug: 'pagrus-caeruleostictus',
    nameKey: 'catalog.fish.pagrusCaruleus',
    scientificName: 'Pagrus caeruleostictus',
    commonNameFR: 'Dorade',
    commonNameEN: 'Bluespotted seabream',
    commonNameAR: 'باغروس منقط أزرق',
    image: '/assets/products/16- Pagrus caeruleostictus.jpeg',
    alt: 'Pagrus caeruleostictus - Bluespotted seabream from Mauritanian Atlantic waters',
    category: 'Courbines / Dorades / Pagres',
    categoryKey: 'catalog.cat.courbinesDorades',
    descriptionKey: 'catalog.desc.pagrusCaruleus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_20',
    slug: 'pseudupeneus-prayensis',
    nameKey: 'catalog.fish.pseudupeneus',
    scientificName: 'Pseudupeneus prayensis',
    commonNameFR: 'Rouget',
    commonNameEN: 'West African goatfish',
    commonNameAR: 'سلطان إبراهيم غرب أفريقيا',
    image: '/assets/products/17- Pseudupeneus prayensis.jpeg',
    alt: 'Pseudupeneus prayensis - West African goatfish from Mauritanian Atlantic waters',
    category: 'Démersaux divers',
    categoryKey: 'catalog.cat.demersauxDivers',
    descriptionKey: 'catalog.desc.pseudupeneus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_21',
    slug: 'zeus-faber',
    nameKey: 'catalog.fish.zeusFaber',
    scientificName: 'Zeus faber',
    commonNameFR: 'Saint-Pierre',
    commonNameEN: 'John Dory',
    commonNameAR: 'سمك القديس بطرس',
    image: '/assets/products/18- Zeus faber.jpeg',
    alt: 'Zeus faber - John Dory from Mauritanian Atlantic waters',
    category: 'Démersaux divers',
    categoryKey: 'catalog.cat.demersauxDivers',
    descriptionKey: 'catalog.desc.zeusFaber',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_22',
    slug: 'argyrosomus-regius',
    nameKey: 'catalog.fish.argyrosomus',
    scientificName: 'Argyrosomus regius',
    commonNameFR: 'Maigre',
    commonNameEN: 'Meagre',
    commonNameAR: 'ميغر',
    image: '/assets/products/19- Argyrosomus Regius.jpeg',
    alt: 'Argyrosomus regius - Meagre from Mauritanian Atlantic waters',
    category: 'Démersaux divers',
    categoryKey: 'catalog.cat.demersauxDivers',
    descriptionKey: 'catalog.desc.argyrosomus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_23',
    slug: 'pomatomus-saltatrix',
    nameKey: 'catalog.fish.pomatomus',
    scientificName: 'Pomatomus saltatrix',
    commonNameFR: 'Tassergal',
    commonNameEN: 'Bluefish',
    commonNameAR: 'بلوفيش',
    image: '/assets/products/20- Pomatomus Saltatrix.jpeg',
    alt: 'Pomatomus saltatrix - Bluefish from Mauritanian Atlantic waters',
    category: 'Démersaux divers',
    categoryKey: 'catalog.cat.demersauxDivers',
    descriptionKey: 'catalog.desc.pomatomus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_24',
    slug: 'branchiostegus-semifasciatus',
    nameKey: 'catalog.fish.branchiostegus',
    scientificName: 'Branchiostegus semifasciatus',
    commonNameFR: 'À confirmer',
    commonNameEN: 'Branchiostegus',
    commonNameAR: 'سمك البلاط نصف المخطط',
    image: '/assets/products/21- Branchiostegus semifasciatus.jpeg',
    alt: 'Branchiostegus semifasciatus from Mauritanian Atlantic waters',
    category: 'Démersaux divers',
    categoryKey: 'catalog.cat.demersauxDivers',
    descriptionKey: 'catalog.desc.branchiostegus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_25',
    slug: 'dicentrarchus-punctatus',
    nameKey: 'catalog.fish.dicentrarchus',
    scientificName: 'Dicentrarchus punctatus',
    commonNameFR: 'Bar tacheté',
    commonNameEN: 'Spotted seabass',
    commonNameAR: 'قاروص منقط',
    image: '/assets/products/22- Dicentrarchus Punctatus.jpeg',
    alt: 'Dicentrarchus punctatus - Spotted seabass from Mauritanian Atlantic waters',
    category: 'Démersaux divers',
    categoryKey: 'catalog.cat.demersauxDivers',
    descriptionKey: 'catalog.desc.dicentrarchus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_26',
    slug: 'plectorhinchus-mediterraneus',
    nameKey: 'catalog.fish.plectorhinchus',
    scientificName: 'Plectorhinchus mediterraneus',
    commonNameFR: 'Grondeur',
    commonNameEN: 'Grunt',
    commonNameAR: 'شفاه حلوة متوسطية',
    image: '/assets/products/23- Plectorhinchus mediterraneus.jpeg',
    alt: 'Plectorhinchus mediterraneus - Grunt from Mauritanian Atlantic waters',
    category: 'Démersaux divers',
    categoryKey: 'catalog.cat.demersauxDivers',
    descriptionKey: 'catalog.desc.plectorhinchus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_27',
    slug: 'anisotremus-surinamensis',
    nameKey: 'catalog.fish.anisotremus',
    scientificName: 'Anisotremus surinamensis',
    commonNameFR: 'Grondeur',
    commonNameEN: 'Grunt',
    commonNameAR: 'مارغيت أسود',
    image: '/assets/products/24- Anisotremus surinamensis.jpeg',
    alt: 'Anisotremus surinamensis - Grunt from Mauritanian Atlantic waters',
    category: 'Démersaux divers',
    categoryKey: 'catalog.cat.demersauxDivers',
    descriptionKey: 'catalog.desc.anisotremus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_28',
    slug: 'trachurus-mediterraneus',
    nameKey: 'catalog.fish.trachurus',
    scientificName: 'Trachurus mediterraneus',
    commonNameFR: 'Chinchard',
    commonNameEN: 'Mediterranean horse mackerel',
    commonNameAR: 'إسقمري حصان متوسطي',
    image: '/assets/products/25- Trachurus mediterraneus.jpeg',
    alt: 'Trachurus mediterraneus - Mediterranean horse mackerel from Mauritanian Atlantic waters',
    category: 'Pélagiques / Chinchards',
    categoryKey: 'catalog.cat.pelagiquesChínchards',
    descriptionKey: 'catalog.desc.trachurus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_29',
    slug: 'trachurus-trachurus',
    nameKey: 'catalog.fish.trachurusTrachurus',
    scientificName: 'Trachurus trachurus',
    commonNameFR: 'Chinchard',
    commonNameEN: 'Atlantic horse mackerel',
    commonNameAR: 'إسقمري حصان أطلسي',
    image: '/assets/products/26- Trachurus Trachurus.jpeg',
    alt: 'Trachurus trachurus - Atlantic horse mackerel from Mauritanian Atlantic waters',
    category: 'Pélagiques / Chinchards',
    categoryKey: 'catalog.cat.pelagiquesChínchards',
    descriptionKey: 'catalog.desc.trachurusTrachurus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_30',
    slug: 'dentex-macrophthalmus',
    nameKey: 'catalog.fish.dentexMacrophthalmus',
    scientificName: 'Dentex macrophthalmus',
    commonNameFR: 'Denté',
    commonNameEN: 'Large-eye dentex',
    commonNameAR: 'دنتكس كبير العيون',
    image: '/assets/products/27- Dentex macrophthalmus.jpeg',
    alt: 'Dentex macrophthalmus - Large-eye dentex from Mauritanian Atlantic waters',
    category: 'Dentés / Sparidés',
    categoryKey: 'catalog.cat.dentesSparides',
    descriptionKey: 'catalog.desc.dentexMacrophthalmus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_31',
    slug: 'dentex-angolensis',
    nameKey: 'catalog.fish.dentexAngolensis',
    scientificName: 'Dentex angolensis',
    commonNameFR: 'Denté',
    commonNameEN: 'Angolan dentex',
    commonNameAR: 'دنتكس أنغولي',
    image: '/assets/products/28- Dentex angolensis.jpeg',
    alt: 'Dentex angolensis - Angolan dentex from Mauritanian Atlantic waters',
    category: 'Dentés / Sparidés',
    categoryKey: 'catalog.cat.dentesSparides',
    descriptionKey: 'catalog.desc.dentexAngolensis',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_32',
    slug: 'campogramma-glaycos',
    nameKey: 'catalog.fish.campogramma',
    scientificName: 'Campogramma glaycos',
    commonNameFR: 'À confirmer',
    commonNameEN: 'Vadigo',
    commonNameAR: 'فاديغو',
    image: '/assets/products/29- Campogramma glaycos.jpeg',
    alt: 'Campogramma glaycos - Vadigo from Mauritanian Atlantic waters',
    category: 'Cas à vérifier',
    categoryKey: 'catalog.cat.casAVerifier',
    descriptionKey: 'catalog.desc.campogramma',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_33',
    slug: 'brotula-barbata',
    nameKey: 'catalog.fish.brotula',
    scientificName: 'Brotula barbata',
    commonNameFR: 'Brotule',
    commonNameEN: 'Bearded brotula',
    commonNameAR: 'بروتولا ذات اللحية',
    image: '/assets/products/30- Brotula barbata.jpeg',
    alt: 'Brotula barbata - Bearded brotula from Mauritanian Atlantic waters',
    category: 'Autres espèces',
    categoryKey: 'catalog.cat.autresEspeces',
    descriptionKey: 'catalog.desc.brotula',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_34',
    slug: 'galeichthys-feliceps',
    nameKey: 'catalog.fish.galeichthys',
    scientificName: 'Galeichthys feliceps',
    commonNameFR: 'Poisson-chat',
    commonNameEN: 'Catfish',
    commonNameAR: 'قطس البحر',
    image: '/assets/products/31- Galeichthys feliceps.jpeg',
    alt: 'Galeichthys feliceps - Catfish from Mauritanian Atlantic waters',
    category: 'Autres espèces',
    categoryKey: 'catalog.cat.autresEspeces',
    descriptionKey: 'catalog.desc.galeichthys',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_35',
    slug: 'scomber-scombrus',
    nameKey: 'catalog.fish.scomber',
    scientificName: 'Scomber scombrus',
    commonNameFR: 'Maquereau',
    commonNameEN: 'Atlantic mackerel',
    commonNameAR: 'إسقمري أطلسي',
    image: '/assets/products/32- Scomber scombrus.jpeg',
    alt: 'Scomber scombrus - Atlantic mackerel from Mauritanian Atlantic waters',
    category: 'Autres espèces',
    categoryKey: 'catalog.cat.autresEspeces',
    descriptionKey: 'catalog.desc.scomber',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_36',
    slug: 'stromateus-fiatola',
    nameKey: 'catalog.fish.stromateus',
    scientificName: 'Stromateus fiatola',
    commonNameFR: 'Fiatole',
    commonNameEN: 'Butterfish',
    commonNameAR: 'ستروماتيوس فضي',
    image: '/assets/products/33- Stromateus fiatola.jpeg',
    alt: 'Stromateus fiatola - Butterfish from Mauritanian Atlantic waters',
    category: 'Autres espèces',
    categoryKey: 'catalog.cat.autresEspeces',
    descriptionKey: 'catalog.desc.stromateus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_37',
    slug: 'mugil-cephalus',
    nameKey: 'catalog.fish.mugilCephalus',
    scientificName: 'Mugil cephalus',
    commonNameFR: 'Mulet',
    commonNameEN: 'Flathead mullet',
    commonNameAR: 'بوري رأس مفلطح',
    image: '/assets/products/34- Mugil cephalus.jpeg',
    alt: 'Mugil cephalus - Flathead mullet from Mauritanian Atlantic waters',
    category: 'Autres espèces',
    categoryKey: 'catalog.cat.autresEspeces',
    descriptionKey: 'catalog.desc.mugilCephalus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_38',
    slug: 'mugil-curema',
    nameKey: 'catalog.fish.mugilCurema',
    scientificName: 'Mugil curema',
    commonNameFR: 'Mulet blanc',
    commonNameEN: 'White mullet',
    commonNameAR: 'بوري أبيض',
    image: '/assets/products/35- Mugil curema.jpeg',
    alt: 'Mugil curema - White mullet from Mauritanian Atlantic waters',
    category: 'Autres espèces',
    categoryKey: 'catalog.cat.autresEspeces',
    descriptionKey: 'catalog.desc.mugilCurema',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_39',
    slug: 'pagellus-bellottii',
    nameKey: 'catalog.fish.pagellus',
    scientificName: 'Pagellus bellottii',
    commonNameFR: 'Pageot',
    commonNameEN: 'Red pandora',
    commonNameAR: 'باجيلوس وردي',
    image: '/assets/products/36- Pagellus bellottii.jpeg',
    alt: 'Pagellus bellottii - Red pandora from Mauritanian Atlantic waters',
    category: 'Autres espèces',
    categoryKey: 'catalog.cat.autresEspeces',
    descriptionKey: 'catalog.desc.pagellus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_40',
    slug: 'brachydeuterus-auritus',
    nameKey: 'catalog.fish.brachydeuterus',
    scientificName: 'Brachydeuterus auritus',
    commonNameFR: 'Grondeur',
    commonNameEN: 'Bigeye grunt',
    commonNameAR: 'نهاش كبير العين',
    image: '/assets/products/37- Brachydeuterus auritus.jpeg',
    alt: 'Brachydeuterus auritus - Bigeye grunt from Mauritanian Atlantic waters',
    category: 'Autres espèces',
    categoryKey: 'catalog.cat.autresEspeces',
    descriptionKey: 'catalog.desc.brachydeuterus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_41',
    slug: 'chloroscombrus-chrysurus',
    nameKey: 'catalog.fish.chloroscombrus',
    scientificName: 'Chloroscombrus chrysurus',
    commonNameFR: 'Plat-plat',
    commonNameEN: 'Atlantic bumper',
    commonNameAR: 'كارانكس أطلسي',
    image: '/assets/products/38- Chloroscombrus chrysurus.jpeg',
    alt: 'Chloroscombrus chrysurus - Atlantic bumper from Mauritanian Atlantic waters',
    category: 'Autres espèces',
    categoryKey: 'catalog.cat.autresEspeces',
    descriptionKey: 'catalog.desc.chloroscombrus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_42',
    slug: 'drepane-africana',
    nameKey: 'catalog.fish.drepane',
    scientificName: 'Drepane africana',
    commonNameFR: 'Forgeron',
    commonNameEN: 'African sicklefish',
    commonNameAR: 'سمكة المنجل الأفريقية',
    image: '/assets/products/39- Drepane africana.jpeg',
    alt: 'Drepane africana - African sicklefish from Mauritanian Atlantic waters',
    category: 'Autres espèces',
    categoryKey: 'catalog.cat.autresEspeces',
    descriptionKey: 'catalog.desc.drepane',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_43',
    slug: 'raja-miraletus',
    nameKey: 'catalog.fish.raja',
    scientificName: 'Raja miraletus',
    commonNameFR: 'Raie',
    commonNameEN: 'Brown ray',
    commonNameAR: 'راجا بنية',
    image: '/assets/products/40- Raja miraletus.jpeg',
    alt: 'Raja miraletus - Brown ray from Mauritanian Atlantic waters',
    category: 'Raies / Sélaciens',
    categoryKey: 'catalog.cat.raiesSelaciens',
    descriptionKey: 'catalog.desc.raja',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_44',
    slug: 'rhinobatos-rhinobatos',
    nameKey: 'catalog.fish.rhinobatos',
    scientificName: 'Rhinobatos rhinobatos',
    commonNameFR: 'Poisson guitare',
    commonNameEN: 'Guitarfish',
    commonNameAR: 'أبو مطرقة الشائع',
    image: '/assets/products/41- Rhinobatos rhinobatos.jpeg',
    alt: 'Rhinobatos rhinobatos - Guitarfish from Mauritanian Atlantic waters',
    category: 'Raies / Sélaciens',
    categoryKey: 'catalog.cat.raiesSelaciens',
    descriptionKey: 'catalog.desc.rhinobatos',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_45',
    slug: 'pomadasys-incisus',
    nameKey: 'catalog.fish.pomadasys',
    scientificName: 'Pomadasys incisus',
    commonNameFR: 'Grondeur',
    commonNameEN: 'Grunt',
    commonNameAR: 'نهاش هجين',
    image: '/assets/products/42- Pomadasys incisus.jpeg',
    alt: 'Pomadasys incisus - Grunt from Mauritanian Atlantic waters',
    category: 'Démersaux suite',
    categoryKey: 'catalog.cat.demersauxSuite',
    descriptionKey: 'catalog.desc.pomadasys',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_46',
    slug: 'galeoides-decadactylus',
    nameKey: 'catalog.fish.galeoides',
    scientificName: 'Galeoides decadactylus',
    commonNameFR: 'Capitaine',
    commonNameEN: 'Lesser African threadfin',
    commonNameAR: 'خيط أفريقي صغير',
    image: '/assets/products/43- Galeoides decadactylus.jpeg',
    alt: 'Galeoides decadactylus - Lesser African threadfin from Mauritanian Atlantic waters',
    category: 'Démersaux suite',
    categoryKey: 'catalog.cat.demersauxSuite',
    descriptionKey: 'catalog.desc.galeoides',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_47',
    slug: 'sardinella-aurita',
    nameKey: 'catalog.fish.sardinellaAurita',
    scientificName: 'Sardinella aurita',
    commonNameFR: 'Sardinelle ronde',
    commonNameEN: 'Round sardinella',
    commonNameAR: 'سردينيلا مستديرة',
    image: '/assets/products/44- Sardinella aurita.jpeg',
    alt: 'Sardinella aurita - Round sardinella from Mauritanian Atlantic waters',
    category: 'Petits pélagiques',
    categoryKey: 'catalog.cat.petitsPelagiques',
    descriptionKey: 'catalog.desc.sardinellaAurita',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_48',
    slug: 'sardinella-maderensis',
    nameKey: 'catalog.fish.sardinellaMaderensis',
    scientificName: 'Sardinella maderensis',
    commonNameFR: 'Sardinelle plate',
    commonNameEN: 'Madeiran sardinella',
    commonNameAR: 'سردينيلا ماديرا',
    image: '/assets/products/45- Sardinella maderensis.jpeg',
    alt: 'Sardinella maderensis - Madeiran sardinella from Mauritanian Atlantic waters',
    category: 'Petits pélagiques',
    categoryKey: 'catalog.cat.petitsPelagiques',
    descriptionKey: 'catalog.desc.sardinellaMaderensis',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_49',
    slug: 'sardina-pilchardus',
    nameKey: 'catalog.fish.sardinaPilchardus',
    scientificName: 'Sardina pilchardus',
    commonNameFR: 'Sardine commune',
    commonNameEN: 'European pilchard',
    commonNameAR: 'سردين أوروبي',
    image: '/assets/products/46- Sardina pilchardus.jpeg',
    alt: 'Sardina pilchardus - European pilchard from Mauritanian Atlantic waters',
    category: 'Petits pélagiques',
    categoryKey: 'catalog.cat.petitsPelagiques',
    descriptionKey: 'catalog.desc.sardinaPilchardus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_50',
    slug: 'diplodus-sargus',
    nameKey: 'catalog.fish.diplodus',
    scientificName: 'Diplodus sargus',
    commonNameFR: 'Sar commun',
    commonNameEN: 'White seabream',
    commonNameAR: 'دبلودوس أبيض',
    image: '/assets/products/47- Diplodus sargus.jpeg',
    alt: 'Diplodus sargus - White seabream from Mauritanian Atlantic waters',
    category: 'Autres espèces',
    categoryKey: 'catalog.cat.autresEspeces',
    descriptionKey: 'catalog.desc.diplodus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_51',
    slug: 'pomadasys-jubelini',
    nameKey: 'catalog.fish.pomadasysJubelini',
    scientificName: 'Pomadasys jubelini',
    commonNameFR: 'Grondeur sompat',
    commonNameEN: 'Sompat grunt',
    commonNameAR: 'نهاش سومبات',
    image: '/assets/products/48- Pomadasys jubelini.png',
    alt: 'Pomadasys jubelini - Sompat grunt from Mauritanian Atlantic waters',
    category: 'Démersaux suite',
    categoryKey: 'catalog.cat.demersauxSuite',
    descriptionKey: 'catalog.desc.pomadasysJubelini',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_52',
    slug: 'sarda-sarda',
    nameKey: 'catalog.fish.sardaSarda',
    scientificName: 'Sarda sarda',
    commonNameFR: 'Bonite à dos rayé',
    commonNameEN: 'Atlantic bonito',
    commonNameAR: 'بونيتو أطلسي',
    image: '/assets/products/49- Sarda sarda.png',
    alt: 'Sarda sarda - Atlantic bonito from Mauritanian Atlantic waters',
    category: 'Thons / Bonites',
    categoryKey: 'catalog.cat.thonsBonites',
    descriptionKey: 'catalog.desc.sardaSarda',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_53',
    slug: 'katsuwonus-pelamis',
    nameKey: 'catalog.fish.katsuwonus',
    scientificName: 'Katsuwonus pelamis',
    commonNameFR: 'Bonite à ventre rayé',
    commonNameEN: 'Skipjack tuna',
    commonNameAR: 'تونة سكيبجاك',
    image: '/assets/products/50- Katsuwonus pelamis.png',
    alt: 'Katsuwonus pelamis - Skipjack tuna from Mauritanian Atlantic waters',
    category: 'Thons / Bonites',
    categoryKey: 'catalog.cat.thonsBonites',
    descriptionKey: 'catalog.desc.katsuwonus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_54',
    slug: 'thunnus-thynnus',
    nameKey: 'catalog.fish.thunnusThynnus',
    scientificName: 'Thunnus thynnus',
    commonNameFR: 'Thon rouge',
    commonNameEN: 'Bluefin tuna',
    commonNameAR: 'تونة زرقاء أطلسية',
    image: '/assets/products/51- Thunnus thynnus.png',
    alt: 'Thunnus thynnus - Bluefin tuna from Mauritanian Atlantic waters',
    category: 'Thons / Bonites',
    categoryKey: 'catalog.cat.thonsBonites',
    descriptionKey: 'catalog.desc.thunnusThynnus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
  {
    id: 'product_55',
    slug: 'oreochromis-niloticus',
    nameKey: 'catalog.fish.oreochromisNiloticus',
    scientificName: 'Oreochromis niloticus',
    commonNameFR: 'Tilapia du Nil',
    commonNameEN: 'Nile tilapia',
    commonNameAR: 'بلطي نيلي',
    image: '/assets/products/52- Oreochromis niloticus.png',
    alt: 'Oreochromis niloticus - Nile tilapia from Mauritanian Atlantic waters',
    category: 'Eau douce',
    categoryKey: 'catalog.cat.eauDouce',
    descriptionKey: 'catalog.desc.oreochromisNiloticus',
    origin: { en: 'FAO 34 — Eastern Central Atlantic', fr: 'FAO 34 — Atlantique Centre-Est', ar: 'FAO 34 — وسط شرق الأطلسي' },
    method: { en: 'Wild-caught', fr: 'Pêche sauvage', ar: 'صيد بري' },
    processing: { en: 'Whole Round (Ungutted)', fr: 'Entier non vidé', ar: 'كامل غير منزوع الأحشاء' },
    packaging: { en: '10 kg or 20 kg carton upon request', fr: 'Carton de 10 kg ou 20 kg sur demande', ar: 'كرتون 10 كغ أو 20 كغ حسب الطلب' },
  },
];

export function getProductBySlug(slug: string): Product | undefined {
  return products.find((p) => p.slug === slug);
}
